import { getDisplayZone } from 'common/types/GetDisplayZone';
import { blankKeyText } from '../../../constants/gridText';

const ZoneKeyCreator = ({ value, data, colDef }) => {
    // Only fall back to singular field when the array is null/undefined (unmigrated data).
    // An empty array means explicitly cleared — don't use the stale singular value.
    let effectiveValue = value;
    if (value == null && data && colDef?.field) {
        const singularField = colDef.field.replace(/Zones$/, 'Zone');
        const singular = data[singularField];
        if (singular) effectiveValue = [singular];
    }
    const zone = Array.isArray(effectiveValue)
        ? effectiveValue[0]
        : effectiveValue;
    if (!zone) {
        return blankKeyText;
    }
    return getDisplayZone(zone, colDef?.field);
};

export default ZoneKeyCreator;
